export default __webpack_public_path__ + "static/media/404.24389df1.svg";